module.exports = __webpack_public_path__ + "assets/icon-star-yellow.5d289b56.svg";